// api/users.ts - UsersController endpoints

import { AxiosResponse } from 'axios';
import $api from './instance';
import { TenantSearchResult } from '@/types/api-types';

export interface ProfileResponse {
  // Базові поля користувача на верхньому рівні
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  avatar?: string;
  role: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  deleted: boolean;
  confirmationToken?: string;
  isEmailConfirmed: boolean;
  unreadNotificationsCount: number;
  // Динамічні секції
  personal?: Record<string, string | null>;
  company?: Record<string, string | null>;
  billing?: Record<string, string | null>;
}

// Payloads for new functions
export interface UpdateGeneralProfilePayload {
  firstname?: string;
  lastname?: string;
  avatar?: string;
}

export interface UpdatePersonalProfilePayload {
  personal: Record<string, string | null>;
}

export interface UpdateCompanyProfilePayload {
  company: Record<string, string | null>;
}

export interface UpdateBillingProfilePayload {
  billing: Record<string, string | null>;
}

export async function searchTenantsForInviteRequest(
  search: string,
  limit: number = 10,
): Promise<AxiosResponse<TenantSearchResult[]>> {
  return $api.get('/users/tenants/search', {
    params: { search, limit },
  });
}

export async function getProfile(): Promise<AxiosResponse<ProfileResponse>> {
  return $api.get('/profile');
}

// New specific update functions
export async function updateGeneralProfile(
  payload: UpdateGeneralProfilePayload,
): Promise<AxiosResponse<ProfileResponse>> {
  return $api.patch('/profile', payload);
}

export async function updatePersonalProfile(
  payload: UpdatePersonalProfilePayload,
): Promise<AxiosResponse<ProfileResponse>> {
  return $api.patch('/profile', payload);
}

export async function updateCompanyProfile(
  payload: UpdateCompanyProfilePayload,
): Promise<AxiosResponse<ProfileResponse>> {
  return $api.patch('/profile', payload);
}

export async function updateBillingProfile(
  payload: UpdateBillingProfilePayload,
): Promise<AxiosResponse<ProfileResponse>> { // Исправлена опечатка здесь
  return $api.patch('/profile', payload);
}

/**
 * Checks if an email is already registered in the system.
 * @param email The email address to check.
 * @returns Promise<AxiosResponse<{ isRegistered: boolean }>> - true if email is registered, false otherwise.
 */
export async function isEmailRegistered(email: string): Promise<AxiosResponse<{ isRegistered: boolean }>> {
  return $api.get('/users/is-email-registered', {
    params: { email },
  });
}
